export default "__VITE_ASSET__BUAeRBQm__"